<template>
    <div class="container">
        <div class="nav_header">
            <h2>实名认证</h2>
        </div>

        <div v-loading="loading">
            <template v-if="data_source">
                <div class="success" v-if="data_source.status == 2">
                    <i class="mark iconfont icon-yirenzheng" :class="data_source.type_name"></i>

                    <el-card class="detail" shadow="hover" :body-style="{ padding: 0 }">
                        <div slot="header" class="header">
                            认证信息
                        </div>
                        <ul class="description">
                            <li>
                                <span>认证类型</span>
                                <span>{{ data_source.type_text }}</span>
                            </li>
                            <template v-if="data_source.type == 1">
                                <li>
                                    <span>认证姓名</span>
                                    <span
                                        >{{ data_source.detail.name }}
                                        <i class="icon iconfont icon-renzheng" :class="data_source.type_name"></i>
                                    </span>
                                </li>
                                <li>
                                    <span>认证手机号码</span>
                                    <span>{{ data_source.detail.mobile }}</span>
                                </li>
                                <li>
                                    <span>认证证件号码</span>
                                    <span>{{ data_source.detail.id_card }}</span>
                                </li>
                            </template>

                            <template v-if="data_source.type == 2">
                                <li>
                                    <span>认证公司名称</span>
                                    <span
                                        >{{ data_source.detail.name }}
                                        <i class="icon iconfont icon-renzheng" :class="data_source.type_name"></i>
                                    </span>
                                </li>

                                <li>
                                    <span>统一社会信用代码</span>
                                    <span>{{ data_source.detail.organization }}</span>
                                </li>
                            </template>

                            <li>
                                <span>认证时间</span>
                                <span>{{ data_source.verified_at | dateformat("YYYY-MM-DD HH:mm") }}</span>
                            </li>
                        </ul>
                    </el-card>

                    <white-space />
                    <el-alert title="认证说明" type="info" description="如需修改认证信息，请联系您的客服经理。" show-icon :closable="false">
                    </el-alert>
                </div>

                <div class="wait" v-if="data_source.status == 1">
                    <i class="icon iconfont icon-shenfenzheng-yirenzheng"></i>
                    <div class="tips">正在进行实名认证...</div>
                    <el-button type="primary" @click="redirect(data_source.verify_url)"
                        >点击继续进行实名认证<i class="el-icon-arrow-right el-icon--right"></i
                    ></el-button>

                    <el-button @click="update_status">更新认证状态<i class="el-icon-refresh"></i></el-button>
                    <el-button @click="on_cancel">取消实名认证<i class="el-icon-close"></i></el-button>
                </div>
            </template>

            <template v-else>
                <el-form ref="_form" :model="form" label-width="150px" class="form" :rules="rules">
                    <el-form-item label="认证类型" prop="type"
                        ><el-radio-group v-model="form.type">
                            <el-radio-button label="1">个人认证</el-radio-button>
                            <el-radio-button label="2">企业认证</el-radio-button>
                        </el-radio-group>
                        <div class="extra">认证成功后，认证类型将不能修改</div>
                    </el-form-item>
                    <template v-if="form.type == 1">
                        <el-form-item label="认证者姓名" prop="name">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>

                        <el-form-item label="认证者证件号码" prop="id_no">
                            <el-input v-model="form.id_no"></el-input>
                        </el-form-item>
                    </template>

                    <template v-if="form.type == 2">
                        <el-form-item label="公司名称" prop="name">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>

                        <el-form-item label="统一社会信用代码" prop="id_no">
                            <el-input v-model="form.id_no"></el-input>
                        </el-form-item>
                    </template>

                    <white-space />

                    <el-form-item>
                        <el-button @click="on_submit" class="pointer" type="primary" :disabled="submitting">提交并进行实名认证</el-button>
                    </el-form-item>
                </el-form>
            </template>
        </div>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        data() {
            return {
                path: "/certification/verify",
                data_source: null,
                loading: false,
                submitting: false,
                form: {
                    type: 1,
                    name: null,
                    mobile: null,
                    id_no: null,
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入名称",
                            trigger: "blur",
                        },
                    ],
                    id_no: [
                        {
                            required: true,
                            message: "请输入证件号码",
                            trigger: "blur",
                        },
                    ],
                },
            };
        },
        created() {
            this.load();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            load() {
                this.loading = true;
                this.$http
                    .get("/certification/verify")
                    .then((response) => {
                        if (response.success) {
                            this.data_source = response.data;
                        }
                    })
                    .catch()
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_submit() {
                this.$refs["_form"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        var new_window = window.open();
                        this.$http
                            .post("/certification/verify/apply", this.form)
                            .then((response) => {
                                if (response.success) {
                                    this.load();
                                    this.$confirm("是否已经完成了实名认证?", "提示", {
                                        confirmButtonText: "是的",
                                        cancelButtonText: "没有",
                                        closeOnPressEscape: false,
                                        type: "warning",
                                    })
                                        .then(() => {
                                            this.update_status();
                                        })
                                        .catch(() => {});

                                    new_window.location = response.data.url;
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: response.message,
                                    });

                                    new_window.close();
                                }
                            })
                            .catch()
                            .then(() => {
                                this.submitting = false;
                            });
                    }
                });
            },
            update_status() {
                this.$http
                    .post("/certification/verify/update_status")
                    .then((response) => {
                        if (response.success) {
                            this.load();
                        }
                    })
                    .catch(() => {});
            },
            on_cancel() {
                this.$confirm("是否要取消正在进行中的实名认证？", "操作确认", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = "处理中...";

                            this.$http;
                            this.$http
                                .post("/certification/verify/cancel")
                                .then((response) => {
                                    if (!response.success) {
                                        instance.callback = () => this.$alert(response.message, "失败");
                                    } else {
                                        this.load();
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    instance.confirmButtonLoading = false;
                                    done();
                                });
                        } else {
                            done();
                        }
                    },
                });
            },
        },
    };
</script>

<style lang="less" scope>
    .container {
        .success {
            position: relative;
            .mark {
                font-size: 120px;
                position: absolute;
                right: 48px;
                top: 48px;
                color: #ff5722;
            }
            .detail {
                .icon {
                    font-size: 14px;
                    &.person {
                        color: #ff5722;
                    }
                    &.company {
                        color: #2196f3;
                    }
                }
            }
        }
        .wait {
            text-align: center;
            .tips {
                margin: 24px auto;
            }
            .icon {
                font-size: 80px;
                margin-bottom: 24px;
                display: block;
                color: #9e9e9e;
            }
        }
        .form {
            width: 460px;
        }
    }
</style>
